import { ADDTOCART, DELETE, QTYDECREMENT, QTYINCREMENT } from "./ActionsType";
import initialCart from "./initialCart";

const cartReducer = (state = initialCart, action) => {
  switch (action.type) {
    case ADDTOCART:
      const isIncludes = state.some((cart) => cart.id === action.payload.id);
      if (isIncludes) {
        return state.map((cart) => {
          if (cart.id === action.payload.id) {
            return {
              ...cart,
              quantity: cart.quantity + 1,
            };
          } else {
            return cart;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.payload.id,
            quantity: 1,
            unitPrice: action.payload.price
          },
        ];
      }

    case QTYINCREMENT:
      return state.map((cart) => {
        if (cart.id === action.payload) {
          return {
            ...cart,
            quantity: cart.quantity + 1,
          };
        } else {
          return cart;
        }
      });

    case QTYDECREMENT:
      return state.map((cart) => {
        if (cart.id === action.payload) {
          return {
            ...cart,
            quantity: cart.quantity - 1,
          };
        } else {
          return cart;
        }
      });

    case DELETE:
      return state.filter((cart) => cart.id !== action.payload);

    default:
      return state;
  }
};

export default cartReducer;
